import { COMPANY_CARD_CONFIG, EMPLOYEE_CARD_CONFIG } from '../../constants';

export const CARD_TYPE_OPTIONS = [COMPANY_CARD_CONFIG, EMPLOYEE_CARD_CONFIG];
